import { List } from 'immutable';
import { buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

const method = 'GET';
const buildRAv2HomeworkResultDetailUrl = (groupId) =>
  buildUrl(`/ra-v2-groups/${groupId}/homework-result-detail`);

export function getRAv2HomeworkResultDetailByGroup(state, groupId) {
  const detailSlice = state
    .get('rootReducer')
    .get('rav2HomeworkResultDetail');

  if (! detailSlice) {
    return new List();
  }

  return detailSlice.get(groupId) || new List();
}

export function isLoadingRAv2HomeworkResultDetail(state, groupId) {
  const callState = ApiCall.find(state, {
    method,
    url: buildRAv2HomeworkResultDetailUrl(groupId),
  });

  return ApiCall.State.isValue(callState) && ApiCall.State.isLoading(callState);
}

export function getUnitCount(state, groupId) {
  const details = getRAv2HomeworkResultDetailByGroup(state, groupId);
  if (! details || details.size === 0) {
    return 0;
  }

  let maxUnits = 0;
  details.forEach((student) => {
    const unitCount = student.unitResults ? student.unitResults.size : 0;
    if (unitCount > maxUnits) {
      maxUnits = unitCount;
    }
  });

  return maxUnits;
}



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultDetail/accessors.js